"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadScript;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Scripts =
/*#__PURE__*/
function () {
  function Scripts() {
    (0, _classCallCheck2.default)(this, Scripts);
    (0, _defineProperty2.default)(this, "observers", []);
    (0, _defineProperty2.default)(this, "added", []);
    (0, _defineProperty2.default)(this, "loaded", []);
  }

  (0, _createClass2.default)(Scripts, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.observers.push(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observers = this.observers.filter(function (fn) {
        return fn != observer;
      });
    }
  }, {
    key: "onScriptLoaded",
    value: function onScriptLoaded(src) {
      this.loaded.push(src);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.observers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var observer = _step.value;
          observer(src);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "isAdded",
    value: function isAdded(script) {
      return this.added.includes(script);
    }
  }, {
    key: "isLoaded",
    value: function isLoaded(script) {
      return this.loaded.includes(script);
    }
  }, {
    key: "load",
    value: function load(src) {
      var _this = this;

      if (this.isAdded(src)) {
        return;
      }

      this.added.push(src);
      var script = document.createElement('script');

      script.onload = function () {
        return _this.onScriptLoaded(src);
      };

      script.src = src;
      document.head.appendChild(script);
    }
  }]);
  return Scripts;
}();

var scripts = window.scripts || new Scripts();

function loadScript(script, callback) {
  var observer = function observer(loadedScript) {
    return loadedScript == script && callback();
  };

  if (scripts.isLoaded(script)) {
    callback();
  } else {
    scripts.addObserver(observer);
    scripts.load(script);
  }

  return {
    isLoaded: function isLoaded() {
      return scripts.isLoaded(script);
    },
    unsubscribe: function unsubscribe() {
      scripts.removeObserver(observer);
    }
  };
}